import Vue from 'vue'
import moment from 'moment';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
})
Vue.filter('formatHour', function(value) {
  if (value) {
    return moment(String(value)).format('hh:mm')
  }
})
Vue.filter('format24to12hrs', function(value) {
  if (value) {
    return value
  }
})
Vue.filter('formatHourName', function(value) {
  if (value) {
    const hours = {
      'hour600am_730am':    '6:00 am  - 7: 30am',
      'hour800am_930am':    '8:00 am  - 9: 30am',
      'hour1000am_1130am':  '10:00 am - 11: 30am',
      'hour1200am_0130pm':  '12:00 am - 1: 30pm',
      'hour200pm_330pm':  '2:00 pm - 3: 30pm',
      'hour400pm_530pm':  '4:00 pm - 5: 30pm',

      'hour600am_700am':    '6:00 am   - 7: 30am',
      'hour800am_900am':    '8:00 am   - 9: 30am',
      'hour1000am_1100am':  '10:00 am  - 11: 30am',
      'hour1100am_1200am':  '12:00 am  - 1: 00pm',
      'hour1200am_0100pm':  '12:00 am  - 1: 30pm',
      
      'hour0300pm_0400pm':  '2:00 pm   - 3: 30pm',
      'hour0500pm_0600pm':  '4:00 pm   - 5: 30pm',

    };
    return hours[value] || value;
  }
})
Vue.filter('formatUserCC', function(value) {
  if (value && value.cc_type && value.cc_number )  {
    return value.cc_type + value.cc_number
  } else {
      return '  -  '
  }
})
Vue.filter('formatParkName', function(value) {
  if (value && value.name)  {
    return value.name;                                      
  } else {
      return '  -  '
  }
})